import React, { useEffect, useState } from "react";
import { Paper, IconButton, Tooltip, Chip } from "@mui/material";
import MUIDataTable from "../../../components/LegacyMuiDataTable";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";

import CustomToolbar from "../../../components/CustomToolbar";
import NavBar from "../../../components/Navbar";
import { deleteGroup, getGroups } from "../../../store/ducks/duckGroups";
import { BorderLinearProgress } from "../../../components/LoadingComponent";
import ConfirmDelete from "../../../components/confirmDelete";
import { useStylesLayout } from "../../../styles/Layout";

import GroupForm from "./components/GroupForm";

const initialValue = {
  id: 0,
  name: "",
  owners: [],
  description: "",
  deleted: false,
  isEconomics: false,
};

const Groups = () => {
  const data = useSelector((state) => state.groups.data);
  const loading = useSelector((state) => state.groups.isLoading);

  const { enqueueSnackbar } = useSnackbar();
  const classes = useStylesLayout();

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [group, setGroup] = useState(initialValue);
  const [isEdit, setEdit] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    dispatch(getGroups());
  }, [dispatch]);

  const handleClickReload = () => {
    dispatch(getGroups());
  };

  const handleClickOpen =
    (groupSelected, isEdit = true) =>
    (event) => {
      event.preventDefault();
      setGroup(groupSelected);
      setEdit(isEdit);

      setOpen(true);
    };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirm = (groupSelected) => (event) => {
    event.preventDefault();

    setGroup(groupSelected);

    setOpenConfirm(true);
  };

  const handleDelete = (event) => {
    event.preventDefault();
    dispatch(deleteGroup(group.id)).then(() =>
      enqueueSnackbar(`Group ${group.name} Deleted succesfully`, {
        variant: "info",
      }),
    );
    handleCloseConfirm();
  };

  const columns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: true,
        display: false,
      },
    },
    {
      name: "deleted",
      label: "Deleted",
      options: {
        filter: true,
        display: false,
        filterType: "dropdown",
        customFilterListOptions: { render: (v) => `Deleted: ${v}` },
        filterList: [false],
      },
    },
    {
      name: "name",
      label: "Name",
      options: {
        display: true,
        filter: true,
      },
    },
    {
      name: "description",
      label: "Description",
      options: {
        filter: true,
      },
    },
    {
      name: "isEconomics",
      label: "Economics Rule",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          return rowData.isEconomics ? <CheckIcon /> : <RemoveIcon />;
        },
      },
    },
    {
      name: "owners",
      label: "Owners",
      options: {
        filter: true,
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          return rowData.owners.length > 0 ? (
            rowData.owners.map((x) => {
              let data = `${x.firstName} - ${x.lastName} - ${x.networkUser}`;

              return <Chip key={`chip-Owner-${x}`} label={data} size="small" />;
            })
          ) : (
            <RemoveIcon />
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          let rowData = data[dataIndex];

          return (
            <div style={{ maxWidth: 250 }}>
              <Tooltip title={"Edit"}>
                <IconButton aria-label="edit" size="small" onClick={handleClickOpen(rowData, true)}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={rowData.deleted ? "Is already removed" : "Delete"}>
                <IconButton
                  aria-label="delete"
                  disabled={rowData.deleted}
                  size="small"
                  onClick={handleConfirm(rowData)}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
        setCellProps: () => ({ style: { width: 130, textAlign: "right" } }),
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    expandableRowsHeader: false,
    selectableRows: "none",
    download: false,
    print: false,
    viewColumns: true,
    customToolbar: () => {
      return (
        <CustomToolbar
          handleClick={handleClickOpen(initialValue)}
          handleReload={handleClickReload}
        />
      );
    },
    //Dense
    setTableProps: () => {
      return {
        padding: "default",
        size: "small",
      };
    },
    textLabels: {
      body: {
        noMatch: loading ? "loading..." : "Sorry, no matching records found",
      },
    },
    setRowProps: (row, dataIndex, _rowIndex) => {
      let deleted = data[dataIndex]?.deleted;

      return (
        deleted && {
          style: { backgroundColor: "Gainsboro" },
          title: "Deleted",
        }
      );
    },
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "420px",
    jumpToPage: true,
  };

  return (
    <>
      <NavBar />
      <Paper className={classes.administrationPaper}>
        {loading && <BorderLinearProgress />}

        <ConfirmDelete
          handleClose={handleCloseConfirm}
          handleDelete={handleDelete}
          message={`Are you sure to Delete the Group with Name: ${group?.name}?`}
          open={openConfirm}
        />
        {open && group && (
          <GroupForm handleClose={handleClose} initialValues={group} isEdit={isEdit} open={open} />
        )}
        <MUIDataTable columns={columns} data={data} options={options} title={"Groups"} />
      </Paper>
    </>
  );
};

export default Groups;
